export type StringTemplateData = {
  [key: string]: any;
};

/**
 * Given a string template like "Hello, {{name}}! Are you {{age}} years old?"
 *   and a data object like { name: 'John', age: 30 },
 *   replaces the placeholders with values from the data object.
 */
export default function interpolate(
  str: string | undefined,
  data: StringTemplateData = {},
) {
  if (!str) {
    return '';
  }
  const regex = /\{\{\s*[\w]*\s*\}\}/g;
  const parts = str.split(regex);
  const properties = str.match(regex) || [];
  const parameters = properties.map((prop) => {
    const arg = prop.replace('{{', '').replace('}}', '').trim();
    const value = data[arg];
    const valueType = typeof value;
    if (valueType === 'undefined' || value === null) {
      return '';
    }
    if (valueType === 'function') {
      return value(arg);
    }
    if (valueType === 'object') {
      return Array.isArray(value) ? value.join(',') : JSON.stringify(value);
    }
    return `${value}`;
  });
  return String.raw({ raw: parts }, ...parameters);
}
